import { Flex, Icon } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { todoItemIconName } from './TodoList/lib';
import { TodoIconProps } from './types';

function TodoIcon({ done = false, target, kind, ...props }: TodoIconProps) {
  return (
    <Flex
      h="50px"
      minW="50px"
      bg={done ? 'green.200' : '#e3e5f5'}
      borderRadius="15px"
      alignItems="center"
      justify="center"
      {...props}
    >
      <Icon
        as={FontAwesomeIcon}
        icon={todoItemIconName(target.__typename, kind)}
        size="lg"
        _groupHover={{ color: 'white' }}
      />
    </Flex>
  );
}

export default TodoIcon;
